var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPomoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51 45",
    style: {
      enableBackground: "new 0 0 51 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,3L26.9,3c-8.2-0.8-15.5,5.1-16.3,13.2c-0.5,5,1.7,10,5.7,13.1c0.9,0.7,1.5,1.8,1.5,2.9v4.1c0,3.2,2.6,5.8,5.9,5.8l0,0 h3.5c3.2,0,5.9-2.6,5.9-5.8l0,0v-4.1c0-1.1,0.5-2.2,1.4-2.9c6.5-4.9,7.8-14.1,2.8-20.6C34.9,5.4,31.1,3.4,26.9,3z M27.3,38.8h-3.5 c-1.4,0-2.5-1.1-2.5-2.5v-2.5h8.6v2.5C29.8,37.7,28.6,38.8,27.3,38.8z M25.5,21.4c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1 c0.6,0,1.1,0.5,1.1,1.1c0,0,0,0,0,0C26.6,20.9,26.1,21.4,25.5,21.4z M32.5,26.7c-1.3,1-2.2,2.3-2.5,3.9h-2.8v-6.1 c2.3-0.9,3.4-3.5,2.4-5.7c-0.9-2.2-3.5-3.3-5.8-2.4c-2.3,0.9-3.4,3.5-2.4,5.7c0.5,1.1,1.3,2,2.4,2.4v6.1H21 c-0.4-1.6-1.3-2.9-2.6-3.9c-5-3.9-5.9-11.1-2-16c2.4-3.1,6.2-4.7,10.2-4.3l0,0c6.3,0.6,11,6.2,10.4,12.5 C36.7,21.9,35,24.7,32.5,26.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPomoc);
export default __webpack_public_path__ + "static/media/pomoc.7efdff0e.svg";
export { ForwardRef as ReactComponent };